// Component that traps focus within itself, built on react-aria's FocusScope.
//
// FocusScope provides Tab containment, focus restoration on unmount, and
// optional auto-focus of the first focusable child. Auto-focus is correct for
// dialogs (WAI-ARIA dialog pattern) but wrong for the screen-level trap that
// mounts on page load — pass autoFocus={false} there so no focus ring appears
// before the user starts keyboard navigation (WCAG 2.4.7).
import { useKeyboardShortcut } from 'platform-specific/keyboardShortcutHandler';
import React from 'react';
import { FocusScope } from 'react-aria';
import { View, type ViewProps } from 'react-native';

const ESCAPE_KEY = 'Escape';

export type FocusLoopViewProps = ViewProps & {
    onCloseLoop: any;
    index: number;
    autoFocus?: boolean;
};

export function FocusLoopView({ children, onCloseLoop, index, autoFocus = true, ...viewProps }: FocusLoopViewProps) {
    useKeyboardShortcut({ shortcutKey: ESCAPE_KEY, callback: onCloseLoop, index });

    return (
        <View {...viewProps}>
            <FocusScope autoFocus={autoFocus} contain restoreFocus>
                <View style={{ flex: 1 }}>{children}</View>
            </FocusScope>
        </View>
    );
}
